import React from 'react';

export default function BrandingForecast43058209() {
  return (
    <div className="p-6 max-w-7xl mx-auto space-y-16">

      {/* ═══════════════════════════════════════════════════════════════════════ */}
      {/* HUPALUPA — ₺200,000 — Şubat 2026                                     */}
      {/* Google Ads + Meta Ads + TikTok Ads                                    */}
      {/* ═══════════════════════════════════════════════════════════════════════ */}
      <div className="bg-white rounded-2xl shadow-sm border overflow-hidden">
        <div className="bg-white border-b p-5 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
          <div className="flex items-center gap-4">
            <div className="rounded-lg px-3 py-1.5">
              <img src="https://hupalupa.com.tr/images/logo_s.png" alt="Hupalupa" className="h-8 w-auto object-contain" />
            </div>
            <div className="ml-1">
              <h2 className="text-lg font-bold text-gray-800">HUPALUPA — Şubat 2026 Medya Planı</h2>
              <p className="text-sm text-gray-500">Google Ads (Search + GDN + YouTube) • Meta Ads (Sales + Reach + Traffic + Video) • TikTok Ads</p>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <span className="inline-flex items-center px-3 py-1 bg-gray-100 text-gray-600 text-xs font-medium rounded-full border border-gray-200">
              Şubat 2026
            </span>
            <span className="inline-flex items-center px-3 py-1.5 bg-gray-800 text-white text-sm font-semibold rounded-full">
              Total: ₺200,000
            </span>
          </div>
        </div>

        <div className="p-6">
          {/* Budget Split Summary */}
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 mb-6">
            <div className="rounded-xl border border-blue-100 bg-blue-50 p-4">
              <div className="flex items-center gap-2 mb-1">
                <img src="/google_ads-512.webp" alt="Google" className="w-5 h-5 object-contain" />
                <span className="text-xs font-medium text-blue-700">Google Ads</span>
              </div>
              <p className="text-xl font-bold text-blue-800">₺80,000</p>
              <p className="text-[10px] text-blue-600 mt-0.5">40% • Search + GDN + YouTube</p>
            </div>
            <div className="rounded-xl border border-indigo-100 bg-indigo-50 p-4">
              <div className="flex items-center gap-2 mb-1">
                <img src="/6033716.png" alt="Meta" className="w-5 h-5 object-contain" />
                <span className="text-xs font-medium text-indigo-700">Meta Ads</span>
              </div>
              <p className="text-xl font-bold text-indigo-800">₺100,000</p>
              <p className="text-[10px] text-indigo-600 mt-0.5">50% • Sales + Reach + Traffic + Video</p>
            </div>
            <div className="rounded-xl border border-gray-200 bg-gray-50 p-4">
              <div className="flex items-center gap-2 mb-1">
                <img src="/tiktokv4.svg" alt="TikTok" className="w-5 h-5 object-contain" />
                <span className="text-xs font-medium text-gray-700">TikTok Ads</span>
              </div>
              <p className="text-xl font-bold text-gray-800">₺20,000</p>
              <p className="text-[10px] text-gray-600 mt-0.5">10% • Video + Traffic + Conversions</p>
            </div>
            <div className="rounded-xl border border-red-100 bg-red-50 p-4">
              <div className="flex items-center gap-2 mb-1">
                <img src="/youtubelogov2.svg" alt="YouTube" className="w-4 h-4 object-contain" />
                <span className="text-xs font-medium text-red-700">YouTube</span>
              </div>
              <p className="text-xl font-bold text-red-800">₺38,000</p>
              <p className="text-[10px] text-red-600 mt-0.5">Google Ads YouTube Video</p>
            </div>
            <div className="rounded-xl border border-gray-200 bg-gray-50 p-4">
              <span className="text-xs font-medium text-gray-700">Total Clicks</span>
              <p className="text-xl font-bold text-gray-800">28.6K</p>
              <p className="text-[10px] text-gray-600 mt-0.5">Google 9.3K + Meta 16K + TikTok 3.2K</p>
            </div>
            <div className="rounded-xl border border-emerald-100 bg-emerald-50 p-4">
              <span className="text-xs font-medium text-emerald-700">Total Reach</span>
              <p className="text-xl font-bold text-emerald-800">1.17M</p>
              <p className="text-[10px] text-emerald-600 mt-0.5">Across all channels (Feb)</p>
            </div>
          </div>

          {/* Campaign Plan Table */}
          <div className="rounded-xl border overflow-hidden mb-8">
            <div className="bg-slate-100 px-4 py-3 font-semibold text-gray-800">Campaign Plan — HUPALUPA Şubat 2026</div>
            <div className="overflow-x-auto">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Platform</th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Campaign Type</th>
                    <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Impressions</th>
                    <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Reach</th>
                    <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Clicks</th>
                    <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">CPC (TRY)</th>
                    <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">CPM (TRY)</th>
                    <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Budget</th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-100">
                  {/* Google Ads */}
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3 text-sm font-medium" rowSpan={3}>
                      <div className="flex items-center gap-2">
                        <img src="/google_ads-512.webp" alt="Google Ads" className="w-5 h-5 object-contain" />
                        <span>Google Ads</span>
                      </div>
                    </td>
                    <td className="px-4 py-3 text-sm">Search</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">7,000</td>
                    <td className="px-4 py-3 text-sm text-right">₺5.0</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right font-medium">₺35,000</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3 text-sm">GDN (Display)</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">2,333</td>
                    <td className="px-4 py-3 text-sm text-right">₺3.0</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right font-medium">₺7,000</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3 text-sm">YouTube Video</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">253,333 views</td>
                    <td className="px-4 py-3 text-sm text-right">₺0.15 CPV</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right font-medium">₺38,000</td>
                  </tr>
                  <tr className="bg-blue-50 font-semibold">
                    <td className="px-4 py-3 text-sm text-blue-800">Google Total</td>
                    <td className="px-4 py-3 text-sm"></td>
                    <td className="px-4 py-3 text-sm text-right text-blue-800">-</td>
                    <td className="px-4 py-3 text-sm text-right text-blue-800">-</td>
                    <td className="px-4 py-3 text-sm text-right text-blue-800">9,333</td>
                    <td className="px-4 py-3 text-sm text-right text-blue-800">-</td>
                    <td className="px-4 py-3 text-sm text-right text-blue-800">-</td>
                    <td className="px-4 py-3 text-sm text-right text-blue-800">₺80,000</td>
                  </tr>

                  {/* Meta Ads */}
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3 text-sm font-medium" rowSpan={4}>
                      <div className="flex items-center gap-2">
                        <img src="/6033716.png" alt="Meta" className="w-5 h-5 object-contain" />
                        <span>Meta Ads</span>
                      </div>
                    </td>
                    <td className="px-4 py-3 text-sm">Engagement</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">8,889</td>
                    <td className="px-4 py-3 text-sm text-right">₺4.5</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right font-medium">₺40,000</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3 text-sm">Reach & Frequency</td>
                    <td className="px-4 py-3 text-sm text-right">1,666,667</td>
                    <td className="px-4 py-3 text-sm text-right">1,165,000</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">₺15.0</td>
                    <td className="px-4 py-3 text-sm text-right font-medium">₺25,000</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3 text-sm">Traffic</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">7,143</td>
                    <td className="px-4 py-3 text-sm text-right">₺2.8</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right font-medium">₺20,000</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3 text-sm">Video Views</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">150,000 views</td>
                    <td className="px-4 py-3 text-sm text-right">₺0.10 CPV</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right font-medium">₺15,000</td>
                  </tr>
                  <tr className="bg-indigo-50 font-semibold">
                    <td className="px-4 py-3 text-sm text-indigo-800">Meta Total</td>
                    <td className="px-4 py-3 text-sm"></td>
                    <td className="px-4 py-3 text-sm text-right text-indigo-800">1,666,667</td>
                    <td className="px-4 py-3 text-sm text-right text-indigo-800">1,165,000</td>
                    <td className="px-4 py-3 text-sm text-right text-indigo-800">16,032</td>
                    <td className="px-4 py-3 text-sm text-right text-indigo-800">₺3.8</td>
                    <td className="px-4 py-3 text-sm text-right text-indigo-800">-</td>
                    <td className="px-4 py-3 text-sm text-right text-indigo-800">₺100,000</td>
                  </tr>

                  {/* TikTok Ads */}
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3 text-sm font-medium" rowSpan={3}>
                      <div className="flex items-center gap-2">
                        <img src="/tiktokv4.svg" alt="TikTok" className="w-5 h-5 object-contain" />
                        <span>TikTok Ads</span>
                      </div>
                    </td>
                    <td className="px-4 py-3 text-sm">In-Feed Video Views</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">133,333 views</td>
                    <td className="px-4 py-3 text-sm text-right">₺0.06 CPV</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right font-medium">₺8,000</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3 text-sm">Traffic</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">2,333</td>
                    <td className="px-4 py-3 text-sm text-right">₺3.0</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right font-medium">₺7,000</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3 text-sm">Conversions</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">909</td>
                    <td className="px-4 py-3 text-sm text-right">₺5.5</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right font-medium">₺5,000</td>
                  </tr>
                  <tr className="bg-gray-100 font-semibold">
                    <td className="px-4 py-3 text-sm text-gray-800">TikTok Total</td>
                    <td className="px-4 py-3 text-sm"></td>
                    <td className="px-4 py-3 text-sm text-right text-gray-800">-</td>
                    <td className="px-4 py-3 text-sm text-right text-gray-800">-</td>
                    <td className="px-4 py-3 text-sm text-right text-gray-800">3,242</td>
                    <td className="px-4 py-3 text-sm text-right text-gray-800">-</td>
                    <td className="px-4 py-3 text-sm text-right text-gray-800">-</td>
                    <td className="px-4 py-3 text-sm text-right text-gray-800">₺20,000</td>
                  </tr>

                  {/* Grand Total */}
                  <tr className="bg-gray-800 text-white font-bold">
                    <td className="px-4 py-3 text-sm">Grand Total</td>
                    <td className="px-4 py-3 text-sm"></td>
                    <td className="px-4 py-3 text-sm text-right">1,666,667</td>
                    <td className="px-4 py-3 text-sm text-right">1,165,000</td>
                    <td className="px-4 py-3 text-sm text-right">28,607</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">₺200,000</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          {/* Disclaimer */}
          <div className="p-4 rounded-xl bg-amber-50 border border-amber-200">
            <div className="flex items-start gap-2.5">
              <div className="flex-shrink-0 mt-0.5">
                <svg className="w-4 h-4 text-amber-500" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                </svg>
              </div>
              <div>
                <p className="text-xs font-semibold text-amber-800">Tahmini Performans Projeksiyonları</p>
                <p className="text-[11px] text-amber-700 mt-1 leading-relaxed">
                  Bu plan, Türkiye dijital reklam pazarındaki güncel benchmark'lara dayalı tahmini projeksiyonlarla hazırlanmıştır.
                  Gerçek sonuçlar; açık artırma dinamikleri, hedef kitle davranışı, mevsimsellik, kreatif performansı ve pazar koşullarına bağlı olarak değişiklik gösterebilir.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>


      {/* ═══════════════════════════════════════════════════════════════════════ */}
      {/* HUPALUPA STORE — ₺400,000 — Şubat 2026                               */}
      {/* Google Ads + Meta Ads                                                  */}
      {/* ═══════════════════════════════════════════════════════════════════════ */}
      <div className="bg-white rounded-2xl shadow-sm border overflow-hidden">
        <div className="bg-white border-b p-5 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
          <div className="flex items-center gap-4">
            <div className="rounded-lg px-3 py-2">
              <img src="https://hupalupa.store/Data/EditorFiles/Devux/logo-1.svg" alt="Hupalupa Store" className="h-8 w-auto object-contain" />
            </div>
            <div className="ml-1">
              <h2 className="text-lg font-bold text-gray-800">HUPALUPA STORE — Şubat 2026 Medya Planı</h2>
              <p className="text-sm text-gray-500">Google Ads (Search + PMAX + Shopping + YouTube + Demand Gen) • Meta Ads (Sales + Reach + Traffic + Video)</p>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <span className="inline-flex items-center px-3 py-1 bg-gray-100 text-gray-600 text-xs font-medium rounded-full border border-gray-200">
              Şubat 2026
            </span>
            <span className="inline-flex items-center px-3 py-1.5 bg-gray-800 text-white text-sm font-semibold rounded-full">
              Total: ₺400,000
            </span>
          </div>
        </div>

        <div className="p-6">
          {/* Budget Split Summary */}
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 mb-6">
            <div className="rounded-xl border border-blue-100 bg-blue-50 p-4">
              <div className="flex items-center gap-2 mb-1">
                <img src="/google_ads-512.webp" alt="Google" className="w-5 h-5 object-contain" />
                <span className="text-xs font-medium text-blue-700">Google Ads</span>
              </div>
              <p className="text-xl font-bold text-blue-800">₺180,000</p>
              <p className="text-[10px] text-blue-600 mt-0.5">45% • Search + PMAX + Shopping + YouTube + DG</p>
            </div>
            <div className="rounded-xl border border-indigo-100 bg-indigo-50 p-4">
              <div className="flex items-center gap-2 mb-1">
                <img src="/6033716.png" alt="Meta" className="w-5 h-5 object-contain" />
                <span className="text-xs font-medium text-indigo-700">Meta Ads</span>
              </div>
              <p className="text-xl font-bold text-indigo-800">₺220,000</p>
              <p className="text-[10px] text-indigo-600 mt-0.5">55% • Sales + Catalog + Reach + Traffic + Video</p>
            </div>
            <div className="rounded-xl border border-red-100 bg-red-50 p-4">
              <div className="flex items-center gap-2 mb-1">
                <img src="/youtubelogov2.svg" alt="YouTube" className="w-4 h-4 object-contain" />
                <span className="text-xs font-medium text-red-700">YouTube</span>
              </div>
              <p className="text-xl font-bold text-red-800">₺30,000</p>
              <p className="text-[10px] text-red-600 mt-0.5">Google Ads YouTube Video</p>
            </div>
            <div className="rounded-xl border border-gray-200 bg-gray-50 p-4">
              <span className="text-xs font-medium text-gray-700">Total Clicks</span>
              <p className="text-xl font-bold text-gray-800">80.8K</p>
              <p className="text-[10px] text-gray-600 mt-0.5">Google 33.9K + Meta 46.9K</p>
            </div>
            <div className="rounded-xl border border-emerald-100 bg-emerald-50 p-4">
              <span className="text-xs font-medium text-emerald-700">Total Reach</span>
              <p className="text-xl font-bold text-emerald-800">2.05M</p>
              <p className="text-[10px] text-emerald-600 mt-0.5">Across all campaigns (Feb)</p>
            </div>
          </div>

          {/* Campaign Plan Table */}
          <div className="rounded-xl border overflow-hidden mb-8">
            <div className="bg-slate-100 px-4 py-3 font-semibold text-gray-800">Campaign Plan — HUPALUPA STORE Şubat 2026</div>
            <div className="overflow-x-auto">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Platform</th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Campaign Type</th>
                    <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Impressions</th>
                    <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Reach</th>
                    <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Clicks</th>
                    <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">CPC (TRY)</th>
                    <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">CPM (TRY)</th>
                    <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Budget</th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-100">
                  {/* Google Ads */}
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3 text-sm font-medium" rowSpan={5}>
                      <div className="flex items-center gap-2">
                        <img src="/google_ads-512.webp" alt="Google Ads" className="w-5 h-5 object-contain" />
                        <span>Google Ads</span>
                      </div>
                    </td>
                    <td className="px-4 py-3 text-sm">Search</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">11,000</td>
                    <td className="px-4 py-3 text-sm text-right">₺5.0</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right font-medium">₺55,000</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3 text-sm">Performance Max</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">10,000</td>
                    <td className="px-4 py-3 text-sm text-right">₺4.5</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right font-medium">₺45,000</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3 text-sm">Shopping</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">10,000</td>
                    <td className="px-4 py-3 text-sm text-right">₺3.0</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right font-medium">₺30,000</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3 text-sm">YouTube Video</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">250,000 views</td>
                    <td className="px-4 py-3 text-sm text-right">₺0.12 CPV</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right font-medium">₺30,000</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3 text-sm">Demand Gen</td>
                    <td className="px-4 py-3 text-sm text-right">1,000,000</td>
                    <td className="px-4 py-3 text-sm text-right">700,000</td>
                    <td className="px-4 py-3 text-sm text-right">2,857</td>
                    <td className="px-4 py-3 text-sm text-right">₺7.0</td>
                    <td className="px-4 py-3 text-sm text-right">₺20.0</td>
                    <td className="px-4 py-3 text-sm text-right font-medium">₺20,000</td>
                  </tr>
                  <tr className="bg-blue-50 font-semibold">
                    <td className="px-4 py-3 text-sm text-blue-800">Google Total</td>
                    <td className="px-4 py-3 text-sm"></td>
                    <td className="px-4 py-3 text-sm text-right text-blue-800">1,000,000</td>
                    <td className="px-4 py-3 text-sm text-right text-blue-800">700,000</td>
                    <td className="px-4 py-3 text-sm text-right text-blue-800">33,857</td>
                    <td className="px-4 py-3 text-sm text-right text-blue-800">-</td>
                    <td className="px-4 py-3 text-sm text-right text-blue-800">-</td>
                    <td className="px-4 py-3 text-sm text-right text-blue-800">₺180,000</td>
                  </tr>

                  {/* Meta Ads */}
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3 text-sm font-medium" rowSpan={4}>
                      <div className="flex items-center gap-2">
                        <img src="/6033716.png" alt="Meta" className="w-5 h-5 object-contain" />
                        <span>Meta Ads</span>
                      </div>
                    </td>
                    <td className="px-4 py-3 text-sm">Sales (Advantage+ & Catalog)</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">36,905</td>
                    <td className="px-4 py-3 text-sm text-right">₺4.2</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right font-medium">₺155,000</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3 text-sm">Reach & Frequency</td>
                    <td className="px-4 py-3 text-sm text-right">1,923,077</td>
                    <td className="px-4 py-3 text-sm text-right">1,345,000</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">₺13.0</td>
                    <td className="px-4 py-3 text-sm text-right font-medium">₺25,000</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3 text-sm">Traffic</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">10,000</td>
                    <td className="px-4 py-3 text-sm text-right">₺2.5</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right font-medium">₺25,000</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3 text-sm">Video Views</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">187,500 views</td>
                    <td className="px-4 py-3 text-sm text-right">₺0.08 CPV</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right font-medium">₺15,000</td>
                  </tr>
                  <tr className="bg-indigo-50 font-semibold">
                    <td className="px-4 py-3 text-sm text-indigo-800">Meta Total</td>
                    <td className="px-4 py-3 text-sm"></td>
                    <td className="px-4 py-3 text-sm text-right text-indigo-800">1,923,077</td>
                    <td className="px-4 py-3 text-sm text-right text-indigo-800">1,345,000</td>
                    <td className="px-4 py-3 text-sm text-right text-indigo-800">46,905</td>
                    <td className="px-4 py-3 text-sm text-right text-indigo-800">₺3.8</td>
                    <td className="px-4 py-3 text-sm text-right text-indigo-800">-</td>
                    <td className="px-4 py-3 text-sm text-right text-indigo-800">₺220,000</td>
                  </tr>

                  {/* Grand Total */}
                  <tr className="bg-gray-800 text-white font-bold">
                    <td className="px-4 py-3 text-sm">Grand Total</td>
                    <td className="px-4 py-3 text-sm"></td>
                    <td className="px-4 py-3 text-sm text-right">2,923,077</td>
                    <td className="px-4 py-3 text-sm text-right">2,045,000</td>
                    <td className="px-4 py-3 text-sm text-right">80,762</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">₺400,000</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          {/* Disclaimer */}
          <div className="p-4 rounded-xl bg-amber-50 border border-amber-200">
            <div className="flex items-start gap-2.5">
              <div className="flex-shrink-0 mt-0.5">
                <svg className="w-4 h-4 text-amber-500" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                </svg>
              </div>
              <div>
                <p className="text-xs font-semibold text-amber-800">Tahmini Performans Projeksiyonları</p>
                <p className="text-[11px] text-amber-700 mt-1 leading-relaxed">
                  Bu plan, Türkiye dijital reklam pazarındaki güncel benchmark'lara dayalı tahmini projeksiyonlarla hazırlanmıştır.
                  Gerçek sonuçlar; açık artırma dinamikleri, hedef kitle davranışı, mevsimsellik, kreatif performansı ve pazar koşullarına bağlı olarak değişiklik gösterebilir.
                  Store odaklı kampanyalar e-ticaret dönüşümü ve ürün satışı hedeflidir.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ═══════════════════════════════════════════════════════════════════════ */}
      {/* APP PROGRAMMATIC — ₺35,000                                          */}
      {/* ═══════════════════════════════════════════════════════════════════════ */}
      <div className="bg-white rounded-2xl shadow-sm border overflow-hidden">
        <div className="bg-white border-b p-5 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
          <div className="flex items-center gap-4">
            <div className="rounded-lg bg-emerald-100 px-3 py-1.5">
              <span className="text-2xl">🎮</span>
            </div>
            <div className="ml-1">
              <h2 className="text-lg font-bold text-gray-800">HUPALUPA — App Programmatic Reklam Planı</h2>
              <p className="text-sm text-gray-500">In-App Display & Video Ads — 15 Popüler Oyun Uygulaması</p>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <span className="inline-flex items-center px-3 py-1 bg-emerald-100 text-emerald-700 text-xs font-medium rounded-full border border-emerald-200">
              Programmatic
            </span>
            <span className="inline-flex items-center px-3 py-1.5 bg-emerald-700 text-white text-sm font-semibold rounded-full">
              Total: ₺35,000
            </span>
          </div>
        </div>

        <div className="p-6 space-y-8">

          {/* Format & Budget Split */}
          <div>
            <h3 className="text-sm font-semibold text-gray-700 mb-3">Reklam Format Dağılımı</h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <div className="rounded-xl border border-purple-100 bg-purple-50 p-4">
                <div className="flex items-center gap-2 mb-1">
                  <span className="text-lg">📱</span>
                  <span className="text-xs font-medium text-purple-700">Interstitial (Tam Ekran)</span>
                </div>
                <p className="text-xl font-bold text-purple-800">₺15,000</p>
                <p className="text-[10px] text-purple-600 mt-0.5">43% • Yüksek görünürlük, geçiş ekranları</p>
              </div>
              <div className="rounded-xl border border-amber-100 bg-amber-50 p-4">
                <div className="flex items-center gap-2 mb-1">
                  <span className="text-lg">🎬</span>
                  <span className="text-xs font-medium text-amber-700">Rewarded Video</span>
                </div>
                <p className="text-xl font-bold text-amber-800">₺12,000</p>
                <p className="text-[10px] text-amber-600 mt-0.5">34% • Kullanıcı gönüllü izleme, yüksek etkileşim</p>
              </div>
              <div className="rounded-xl border border-sky-100 bg-sky-50 p-4">
                <div className="flex items-center gap-2 mb-1">
                  <span className="text-lg">📐</span>
                  <span className="text-xs font-medium text-sky-700">Banner (320×50 / 300×250)</span>
                </div>
                <p className="text-xl font-bold text-sky-800">₺8,000</p>
                <p className="text-[10px] text-sky-600 mt-0.5">23% • Sürekli görünürlük, marka bilinirliği</p>
              </div>
            </div>
          </div>

          {/* Tahmini Performans */}
          <div>
            <h3 className="text-sm font-semibold text-gray-700 mb-3">Tahmini Performans Metrikleri</h3>
            <div className="grid grid-cols-2 md:grid-cols-5 gap-3">
              {[
                { label: 'Toplam Gösterim', value: '450,000+', sub: 'Ort. CPM: ₺78', color: 'text-gray-800' },
                { label: 'Video Views', value: '85,000+', sub: '%95 VTR hedefi', color: 'text-purple-700' },
                { label: 'Tıklama', value: '5,400+', sub: 'Ort. CTR: %1.2', color: 'text-blue-700' },
                { label: 'Unique Reach', value: '180,000+', sub: 'Ort. frekans: 2.5x', color: 'text-emerald-700' },
                { label: 'Site Ziyareti', value: '3,200+', sub: 'Post-click & view-through', color: 'text-amber-700' },
              ].map((m, i) => (
                <div key={i} className="rounded-xl border bg-gray-50 p-3 text-center">
                  <p className="text-[10px] text-gray-500 uppercase tracking-wider">{m.label}</p>
                  <p className={`text-lg font-bold ${m.color} mt-1`}>{m.value}</p>
                  <p className="text-[10px] text-gray-400 mt-0.5">{m.sub}</p>
                </div>
              ))}
            </div>
          </div>

          {/* 15 App List */}
          <div>
            <div className="flex items-center gap-3 mb-3">
              <span className="inline-flex items-center px-2.5 py-1 bg-violet-100 text-violet-700 text-[11px] font-bold rounded-full">TARGETING 1</span>
              <h3 className="text-sm font-semibold text-gray-700">Çocuk Oyun Uygulamaları — 3-7 Yaş Kitle</h3>
              <span className="inline-flex items-center px-3 py-1 bg-emerald-700 text-white text-xs font-semibold rounded-full ml-auto">₺35,000</span>
            </div>
            <div className="overflow-x-auto">
              <table className="min-w-full border border-gray-200 rounded-xl overflow-hidden">
                <thead>
                  <tr className="bg-gray-800 text-white text-[11px]">
                    <th className="px-4 py-3 text-left">#</th>
                    <th className="px-4 py-3 text-left">Uygulama</th>
                    <th className="px-4 py-3 text-left">Kategori</th>
                    <th className="px-4 py-3 text-left">Geliştirici</th>
                    <th className="px-4 py-3 text-right">TR İndirme</th>
                    <th className="px-4 py-3 text-left">Hedef Kitle</th>
                    <th className="px-4 py-3 text-left">Format</th>
                    <th className="px-4 py-3 text-left">Reklam Ağı</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-100 text-sm">
                  {[
                    { n: 'Talking Tom & Friends', cat: 'Sanal Evcil Hayvan', dev: 'Outfit7', dl: '500M+, ad-supported', aud: '3-7 yaş, çok popüler, ağır reklam', fmt: 'Interstitial + Rewarded', ad: 'AdMob + Unity' },
                    { n: 'My Talking Angela 2', cat: 'Sanal Evcil Hayvan', dev: 'Outfit7', dl: '100M+, ad-supported', aud: '3-7 yaş, kız çocuklar ağırlıklı', fmt: 'Interstitial + Video', ad: 'AdMob + Unity' },
                    { n: 'BabyBus Kids Games', cat: 'Çocuk Oyun Serisi', dev: 'BabyBus', dl: '500M+ (seri), ad-supported', aud: '2-5 yaş, çok sayıda mini oyun', fmt: 'Interstitial + Banner', ad: 'AdMob' },
                    { n: 'Paw Patrol: Rescue World', cat: 'Lisanslı Çocuk Oyun', dev: 'Nickelodeon', dl: '50M+, freemium', aud: '3-6 yaş, TV ile çapraz popülerlik', fmt: 'Interstitial + Video', ad: 'AdMob' },
                    { n: 'Peppa Pig: World Adventures', cat: 'Lisanslı Çocuk Oyun', dev: 'Hasbro', dl: '10M+, freemium', aud: '2-5 yaş, çok tanınan karakter', fmt: 'Interstitial + Banner', ad: 'AdMob' },
                    { n: 'CoComelon Play with JJ', cat: 'Çocuk Eğlence', dev: 'Moonbug', dl: '10M+, ad-supported', aud: '2-5 yaş, YouTube #1 çocuk kanalı', fmt: 'Interstitial + Rewarded', ad: 'AdMob' },
                    { n: 'Baby Shark World', cat: 'Çocuk Eğlence', dev: 'Pinkfong', dl: '50M+, ad-supported', aud: '2-6 yaş, viral şarkı IP\'si', fmt: 'Interstitial + Video', ad: 'AdMob' },
                    { n: 'Toca Life World', cat: 'Yaratıcı Oyun', dev: 'Toca Boca', dl: '100M+, freemium', aud: '4-7 yaş, açık uçlu yaratıcılık', fmt: 'Interstitial + Video', ad: 'AdMob + Meta AN' },
                    { n: 'Sago Mini World', cat: 'Çocuk Keşif', dev: 'Sago Mini', dl: '5M+, freemium', aud: '2-5 yaş, okul öncesi keşif', fmt: 'Interstitial + Banner', ad: 'AdMob' },
                    { n: 'Lego Duplo World', cat: 'Yaratıcı İnşa', dev: 'LEGO System', dl: '10M+, freemium', aud: '2-5 yaş, LEGO markası güveni', fmt: 'Rewarded Video', ad: 'AdMob' },
                    { n: 'Dr. Panda Town', cat: 'Çocuk Simülasyon', dev: 'Dr. Panda', dl: '5M+, freemium', aud: '3-7 yaş, rol yapma oyunu', fmt: 'Interstitial + Banner', ad: 'AdMob' },
                    { n: 'Angry Birds 2', cat: 'Fizik Bulmaca', dev: 'Rovio', dl: '100M+, ad-supported', aud: '4-8 yaş, basit mekanik', fmt: 'Interstitial + Rewarded', ad: 'AdMob + ironSource' },
                    { n: 'Cut the Rope 3', cat: 'Fizik Bulmaca', dev: 'ZeptoLab', dl: '50M+ (seri), freemium', aud: '4-8 yaş, Om Nom karakteri', fmt: 'Interstitial + Video', ad: 'AdMob + Unity' },
                    { n: 'Fruit Ninja 2', cat: 'Arcade', dev: 'Halfbrick', dl: '10M+, ad-supported', aud: '4-8 yaş, basit dokunmatik', fmt: 'Interstitial + Banner', ad: 'AdMob + Unity' },
                    { n: 'Disney Coloring World', cat: 'Boyama / Yaratıcılık', dev: 'StoryToys', dl: '10M+, freemium', aud: '3-7 yaş, Disney karakterleri', fmt: 'Interstitial + Rewarded', ad: 'AdMob' },
                  ].map((app, i) => (
                    <tr key={i} className={`hover:bg-gray-50 ${i % 2 === 0 ? 'bg-white' : 'bg-gray-50/50'}`}>
                      <td className="px-4 py-3 text-xs text-gray-400 font-mono">{i + 1}</td>
                      <td className="px-4 py-3 font-semibold text-gray-800">{app.n}</td>
                      <td className="px-4 py-3 text-xs text-gray-600">{app.cat}</td>
                      <td className="px-4 py-3 text-xs text-gray-500">{app.dev}</td>
                      <td className="px-4 py-3 text-xs text-right text-gray-600">{app.dl}</td>
                      <td className="px-4 py-3 text-xs text-gray-500">{app.aud}</td>
                      <td className="px-4 py-3">
                        <span className="inline-block px-2 py-0.5 text-[10px] bg-gray-100 text-gray-600 rounded-full">{app.fmt}</span>
                      </td>
                      <td className="px-4 py-3">
                        <span className="inline-block px-2 py-0.5 text-[10px] bg-violet-100 text-violet-700 rounded-full">{app.ad}</span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* Targeting 2 — Ebeveyn Uygulamaları */}
          <div>
            <div className="flex items-center gap-3 mb-3">
              <span className="inline-flex items-center px-2.5 py-1 bg-rose-100 text-rose-700 text-[11px] font-bold rounded-full">TARGETING 2</span>
              <h3 className="text-sm font-semibold text-gray-700">Ebeveyn & Aile Uygulamaları — Anne-Baba Kitle</h3>
              <span className="inline-flex items-center px-3 py-1 bg-rose-700 text-white text-xs font-semibold rounded-full ml-auto">₺35,000</span>
            </div>
            <div className="overflow-x-auto">
              <table className="min-w-full border border-gray-200 rounded-xl overflow-hidden">
                <thead>
                  <tr className="bg-rose-800 text-white text-[11px]">
                    <th className="px-4 py-3 text-left">#</th>
                    <th className="px-4 py-3 text-left">Uygulama</th>
                    <th className="px-4 py-3 text-left">Kategori</th>
                    <th className="px-4 py-3 text-left">Geliştirici</th>
                    <th className="px-4 py-3 text-right">İndirme</th>
                    <th className="px-4 py-3 text-left">Hedef Kitle</th>
                    <th className="px-4 py-3 text-left">Format</th>
                    <th className="px-4 py-3 text-left">Reklam Ağı</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-100 text-sm">
                  {[
                    { n: 'Findmykids', cat: 'Çocuk GPS Takip', dev: 'Findmykids Ltd', dl: '10M+ (hft. 45K TR)', aud: '30-45 yaş, okul çağı ebeveynler', fmt: 'Interstitial + Banner', ad: 'AdMob' },
                    { n: 'Kids360', cat: 'Ebeveyn Kontrol', dev: 'Antura Tech', dl: '5M+', aud: '28-45 yaş, dijital güvenlik', fmt: 'Banner + Interstitial', ad: 'AdMob' },
                    { n: 'AirDroid Parental', cat: 'Uzaktan Takip', dev: 'Sand Studio', dl: '10M+', aud: '30-45 yaş, teknoloji bilinçli', fmt: 'Interstitial + Banner', ad: 'AdMob' },
                    { n: 'Hamilelik+ (Pregnancy+)', cat: 'Hamilelik Takip', dev: 'Health & Parenting', dl: '40M+', aud: 'Hamile kadınlar & eşleri', fmt: 'Interstitial + Video', ad: 'AdMob + Meta AN' },
                    { n: 'PepApp', cat: 'Kadın Sağlık Asistanı', dev: 'PepApp 🇹🇷', dl: 'TR yapımı, freemium', aud: '18-40 yaş kadın, döngü/hamilelik', fmt: 'Banner + Interstitial', ad: 'AdMob' },
                    { n: 'BabyCenter', cat: 'Hamilelik & Bebek', dev: 'BabyCenter LLC', dl: '10M+', aud: 'Hamile kadınlar & 0-3 yaş anneler', fmt: 'Banner + Native', ad: 'AdMob + Native' },
                    { n: 'Bebek+ (Baby+)', cat: 'Bebek Gelişim', dev: 'Philips', dl: '5M+, freemium', aud: '25-40 yaş, 0-2 yaş ebeveynler', fmt: 'Interstitial + Banner', ad: 'AdMob' },
                    { n: 'Babysfer', cat: 'Bebek Takip', dev: 'Babysfer', dl: '75M+ (global), freemium', aud: '25-40 yaş, yeni anneler/babalar', fmt: 'Banner + Native', ad: 'AdMob' },
                    { n: 'Life360', cat: 'Aile Konum Paylaşımı', dev: 'Life360 Inc.', dl: '50M+, freemium', aud: '28-50 yaş, aile güvenliği', fmt: 'Interstitial + Banner', ad: 'AdMob + Meta AN' },
                    { n: 'Pollog Family', cat: 'Aile Asistanı', dev: 'Pollog', dl: '58K aktif (TR)', aud: '25-45 yaş, aile organizasyonu', fmt: 'Banner + Native', ad: 'AdMob' },
                    { n: 'Cozi Family Organizer', cat: 'Aile Takvim', dev: 'Cozi Inc.', dl: '10M+, ad-supported', aud: '28-45 yaş, organize ebeveyn', fmt: 'Banner + Interstitial', ad: 'AdMob' },
                    { n: 'Flo Kadın Sağlık', cat: 'Döngü & Hamilelik', dev: 'Flo Health', dl: '100M+, freemium', aud: '18-42 yaş kadın, sağlık takip', fmt: 'Interstitial + Native', ad: 'AdMob + Meta AN' },
                    { n: 'Clue Döngü Takip', cat: 'Kadın Sağlık', dev: 'BioWink', dl: '50M+, freemium', aud: '18-40 yaş kadın, döngü/doğurganlık', fmt: 'Banner + Interstitial', ad: 'AdMob' },
                    { n: 'What to Expect', cat: 'Hamilelik & Bebek', dev: 'Everyday Health', dl: '10M+, ad-supported', aud: '22-40 yaş, hamile & yeni anne', fmt: 'Banner + Native', ad: 'AdMob + Native' },
                    { n: 'Ovia Parenting', cat: 'Bebek Gelişim', dev: 'Ovia Health', dl: '5M+, ad-supported', aud: '24-40 yaş, 0-3 yaş ebeveynler', fmt: 'Banner + Interstitial', ad: 'AdMob' },
                  ].map((app, i) => (
                    <tr key={i} className={`hover:bg-gray-50 ${i % 2 === 0 ? 'bg-white' : 'bg-rose-50/30'}`}>
                      <td className="px-4 py-3 text-xs text-gray-400 font-mono">{i + 1}</td>
                      <td className="px-4 py-3 font-semibold text-gray-800">{app.n}</td>
                      <td className="px-4 py-3 text-xs text-gray-600">{app.cat}</td>
                      <td className="px-4 py-3 text-xs text-gray-500">{app.dev}</td>
                      <td className="px-4 py-3 text-xs text-right text-gray-600">{app.dl}</td>
                      <td className="px-4 py-3 text-xs text-gray-500">{app.aud}</td>
                      <td className="px-4 py-3">
                        <span className="inline-block px-2 py-0.5 text-[10px] bg-gray-100 text-gray-600 rounded-full">{app.fmt}</span>
                      </td>
                      <td className="px-4 py-3">
                        <span className="inline-block px-2 py-0.5 text-[10px] bg-rose-100 text-rose-700 rounded-full">{app.ad}</span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* Targeting 3 — Eğitim Uygulamaları */}
          <div>
            <div className="flex items-center gap-3 mb-3">
              <span className="inline-flex items-center px-2.5 py-1 bg-blue-100 text-blue-700 text-[11px] font-bold rounded-full">TARGETING 3</span>
              <h3 className="text-sm font-semibold text-gray-700">Eğitim Uygulamaları — 3-9 Yaş Çocuk Kitle</h3>
              <span className="inline-flex items-center px-3 py-1 bg-blue-700 text-white text-xs font-semibold rounded-full ml-auto">₺35,000</span>
            </div>
            <div className="overflow-x-auto">
              <table className="min-w-full border border-gray-200 rounded-xl overflow-hidden">
                <thead>
                  <tr className="bg-blue-800 text-white text-[11px]">
                    <th className="px-4 py-3 text-left">#</th>
                    <th className="px-4 py-3 text-left">Uygulama</th>
                    <th className="px-4 py-3 text-left">Kategori</th>
                    <th className="px-4 py-3 text-left">Geliştirici</th>
                    <th className="px-4 py-3 text-right">İndirme</th>
                    <th className="px-4 py-3 text-left">Hedef Kitle</th>
                    <th className="px-4 py-3 text-left">Format</th>
                    <th className="px-4 py-3 text-left">Reklam Ağı</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-100 text-sm">
                  {[
                    { n: 'Lingokids', cat: 'Çocuk İngilizce', dev: 'Lingokids', dl: '160M+ aile, freemium', aud: '2-8 yaş, oyunla İngilizce', fmt: 'Rewarded Video', ad: 'AdMob + Meta AN' },
                    { n: 'Tiny Minies', cat: 'Eğitici Oyun', dev: 'Tiny Minies 🇹🇷', dl: '1M+, freemium', aud: '2-6 yaş, ödüllü tasarım, 100+ oyun', fmt: 'Interstitial + Video', ad: 'AdMob' },
                    { n: 'ABCmouse', cat: 'Okul Öncesi Eğitim', dev: 'Age of Learning', dl: '10M+, freemium', aud: '2-8 yaş, okuma/matematik/bilim', fmt: 'Interstitial + Video', ad: 'AdMob' },
                    { n: 'Endless Alphabet', cat: 'Kelime Öğrenme', dev: 'Originator Inc.', dl: '5M+, freemium', aud: '3-7 yaş, harf & kelime tanıma', fmt: 'Interstitial + Banner', ad: 'AdMob' },
                    { n: 'Homer (Begin)', cat: 'Okuma Öğrenme', dev: 'Homer / Begin', dl: '5M+, freemium', aud: '3-8 yaş, fonetik/okuma', fmt: 'Interstitial + Banner', ad: 'AdMob' },
                    { n: 'Papumba Academy', cat: 'Doğa & Hayvan Eğitim', dev: 'Papumba', dl: '5M+, freemium', aud: '2-7 yaş, hayvan/doğa keşif', fmt: 'Interstitial + Video', ad: 'AdMob' },
                    { n: 'Kiddopia', cat: 'Eğitim Oyunları', dev: 'Kiddopia Inc.', dl: '10M+, freemium', aud: '2-7 yaş, 1000+ aktivite', fmt: 'Interstitial + Rewarded', ad: 'AdMob' },
                    { n: 'Moose Math', cat: 'Çocuk Matematik', dev: 'Duck Duck Moose', dl: '5M+, freemium', aud: '3-7 yaş, sayı/şekil öğrenme', fmt: 'Interstitial + Banner', ad: 'AdMob' },
                    { n: 'Todo Math', cat: 'Çocuk Matematik', dev: 'Enuma Inc.', dl: '5M+, freemium', aud: '3-8 yaş, temel matematik', fmt: 'Banner + Interstitial', ad: 'AdMob' },
                    { n: 'PBS Kids Games', cat: 'Eğitici Oyun', dev: 'PBS Kids', dl: '10M+, ad-supported', aud: '3-8 yaş, çizgi film bağlantılı', fmt: 'Interstitial + Banner', ad: 'AdMob' },
                    { n: 'Buddy.ai', cat: 'AI İngilizce Konuşma', dev: 'AI Buddy Inc.', dl: '5M+, freemium', aud: '4-9 yaş, AI ile konuşma pratiği', fmt: 'Interstitial + Rewarded', ad: 'AdMob' },
                    { n: 'Khan Academy Kids', cat: 'Genel Eğitim', dev: 'Khan Academy', dl: '10M+, ücretsiz', aud: '2-8 yaş, okuma/mat/sosyal', fmt: 'Banner + Native', ad: 'AdMob' },
                    { n: 'Moose Toys - Shopkins', cat: 'Koleksiyon Oyun', dev: 'Mighty Kingdom', dl: '10M+, ad-supported', aud: '4-8 yaş, koleksiyon/alışveriş', fmt: 'Interstitial + Video', ad: 'AdMob' },
                    { n: 'Noggin (Nick Jr)', cat: 'Eğitici Video & Oyun', dev: 'Nickelodeon', dl: '10M+, freemium', aud: '2-7 yaş, çizgi film + eğitici oyun', fmt: 'Interstitial + Video', ad: 'AdMob' },
                    { n: 'Poio Read', cat: 'Okuma Öğrenme', dev: 'Poio', dl: '1M+, freemium', aud: '3-8 yaş, kendi kendine okuma', fmt: 'Interstitial + Banner', ad: 'AdMob' },
                  ].map((app, i) => (
                    <tr key={i} className={`hover:bg-gray-50 ${i % 2 === 0 ? 'bg-white' : 'bg-blue-50/30'}`}>
                      <td className="px-4 py-3 text-xs text-gray-400 font-mono">{i + 1}</td>
                      <td className="px-4 py-3 font-semibold text-gray-800">{app.n}</td>
                      <td className="px-4 py-3 text-xs text-gray-600">{app.cat}</td>
                      <td className="px-4 py-3 text-xs text-gray-500">{app.dev}</td>
                      <td className="px-4 py-3 text-xs text-right text-gray-600">{app.dl}</td>
                      <td className="px-4 py-3 text-xs text-gray-500">{app.aud}</td>
                      <td className="px-4 py-3">
                        <span className="inline-block px-2 py-0.5 text-[10px] bg-gray-100 text-gray-600 rounded-full">{app.fmt}</span>
                      </td>
                      <td className="px-4 py-3">
                        <span className="inline-block px-2 py-0.5 text-[10px] bg-blue-100 text-blue-700 rounded-full">{app.ad}</span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* Targeting Seçim Kriterleri */}
          <div>
            <h3 className="text-sm font-semibold text-gray-700 mb-3">Targeting Stratejisi & Seçim Kriterleri</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
              <div className="rounded-xl border border-violet-200 bg-violet-50/50 p-4">
                <p className="text-xs font-semibold text-violet-800 mb-2">🎮 Targeting 1 — Çocuk Oyunları (3-7)</p>
                <p className="text-[11px] text-gray-600 leading-relaxed">
                  Talking Tom (500M+), BabyBus, Toca Life, Paw Patrol, CoComelon gibi 3-7 yaş çocukların 
                  en çok kullandığı oyunlar. Tümü AdMob/Unity üzerinden reklam gösteren ad-supported uygulamalar.
                </p>
              </div>
              <div className="rounded-xl border border-rose-200 bg-rose-50/50 p-4">
                <p className="text-xs font-semibold text-rose-800 mb-2">👨‍👩‍👧 Targeting 2 — Ebeveyn</p>
                <p className="text-[11px] text-gray-600 leading-relaxed">
                  Çocuk takip (Findmykids, Kids360), hamilelik (Pregnancy+, BabyCenter, Flo), 
                  aile organizasyon (Life360, Cozi) — tümü AdMob/Meta AN üzerinden reklam alan freemium uygulamalar. 
                  Satın alma kararını veren 25-50 yaş ebeveyn kitleye direkt erişim.
                </p>
              </div>
              <div className="rounded-xl border border-blue-200 bg-blue-50/50 p-4">
                <p className="text-xs font-semibold text-blue-800 mb-2">📚 Targeting 3 — Eğitim</p>
                <p className="text-[11px] text-gray-600 leading-relaxed">
                  Duolingo (TR #1 eğitim), Toca Boca, Lingokids, Photomath, Quizlet — tümü AdMob/Unity/ironSource 
                  üzerinden reklam alan freemium eğitim uygulamaları. Tiny Minies (TR yapımı) dahil. 
                  Devlet/abonelik appleri çıkarıldı, sadece programmatic envanter olanlar.
                </p>
              </div>
              <div className="rounded-xl border border-gray-200 bg-white p-4">
                <p className="text-xs font-semibold text-gray-700 mb-2">🔄 Çapraz Strateji</p>
                <p className="text-[11px] text-gray-600 leading-relaxed">
                  Üç targeting birlikte çalışır: Çocuklar oyunlarda (T1) markayı tanır → eğitim applerinde (T3) 
                  tekrar görür → ebeveynler (T2) kendi applerinde karşılaşıp satın alır. 3 temas noktası = 3x dönüşüm.
                </p>
              </div>
            </div>
          </div>

          {/* Targeting & Optimization Notes */}
          <div className="p-4 rounded-xl bg-emerald-50 border border-emerald-200">
            <div className="flex items-start gap-2.5">
              <div className="flex-shrink-0 mt-0.5">
                <svg className="w-4 h-4 text-emerald-600" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                </svg>
              </div>
              <div>
                <p className="text-xs font-semibold text-emerald-800">Optimizasyon Stratejisi</p>
                <ul className="text-[11px] text-emerald-700 mt-1.5 leading-relaxed space-y-1 list-disc pl-4">
                  <li><strong>Geo-targeting:</strong> Türkiye geneli, İstanbul-Ankara-İzmir-Bursa ağırlıklı</li>
                  <li><strong>Frequency cap:</strong> Kullanıcı başına günde max 3 gösterim, haftalık max 12</li>
                  <li><strong>Viewability:</strong> %70+ viewability hedefi, MOAT/IAS doğrulamalı</li>
                  <li><strong>Brand Safety:</strong> Tüm yerleşimler IAB kategorileriyle filtrelenir, yaş uygunluğu kontrol edilir</li>
                  <li><strong>A/B Test:</strong> Interstitial vs Rewarded Video performansı ilk hafta test edilir, bütçe yeniden dağıtılır</li>
                  <li><strong>Retargeting:</strong> Reklama tıklayan kullanıcılar Meta/Google remarketing listelerine eklenir</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  );
}
